import React from 'react';

import { EditSecurityPinView } from '../../account-settings/components/edit-security-pin/EditSecurityPinView';
import { ResetPinLayerData } from './useResetPinLayer';
import { createBridgeLayerRender } from '../../../shared/utils/create-bridge-layer-render';

export const resetPinLayerRender = createBridgeLayerRender<ResetPinLayerData>(
  (data) => data.translationHandler('accountSettings.edit.pin.verification.title'),
  (data) => (
    <EditSecurityPinView
      authService={data.authService}
      translationHandler={data.translationHandler}
      trackingManager={data.trackingManager}
      localeCode={data.localeCode}
      isCanada={data.isCanada}
      onTitleChange={() => {}}
      onSuccess={data.onSuccess}
      onChange={data.onChange}
    />
  ),
);
